import React, { useCallback } from 'react'
import MediaContent from 'components/partials/MediaContent'
import IconArrowRight from 'components/partials/IconArrowRight'
import Description from 'components/partials/Description'
import MediaList from 'components/partials/MediaList'
import Breadcrumb from 'components/Breadcrumb'
import { Link } from 'components/Link'
import ViewModeContext from 'contexts/ViewModeContext'
import useClickLogger from 'api/ClickLogger'

function QuickLinkTemplate({ ...doc }) {
  return (
    <ViewModeContext.Consumer>
      {context => context.isTable ? (
        <QuickLinkTable {...doc} />
      ) : (
        <QuickLinkTeaser {...doc} />
      )}
    </ViewModeContext.Consumer>
  )
}

export default QuickLinkTemplate

function QuickLinkTeaser({
  title,
  text: preamble_cutoff,
  url,
  _click,
  __breadcrumb__,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <MediaList onClick={trackResultClick}>
      <MediaContent>
        <Link href={url}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
          <IconArrowRight />
        </Link>
        <Description text={preamble_cutoff} />
        <Breadcrumb links={__breadcrumb__} modifierClasses="u-mt-50" disabled />
      </MediaContent>
    </MediaList>
  )
}

function QuickLinkTable({
  title,
  text: preamble_cutoff,
  url,
  _click,
  tableHeaders = []
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <tr onClick={trackResultClick} style={{ cursor: 'pointer' }}>
      <td>
        <div className='media'>
          <MediaContent>
            <Link href={url}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
              <IconArrowRight />
            </Link>
            <Description text={preamble_cutoff} />
          </MediaContent>
        </div>
      </td>
      {/* Adding empty cells to match other content in table */}
      {tableHeaders.map(() => (
        <td />
      ))}
    </tr>
  )
}
